//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import cloneDeep from 'lodash.clonedeep'
import { axiosGet, axiosPost } from '../../axios/axios.js'
import { getPropertyIcon, transformPropertyConfiguration } from './cardConfigurations.js'
import CardSectionProperties from './CardSectionProperties.vue'
import CardSectionDocuments from './CardSectionDocuments.vue'
import { EventBus } from '../../EventBus/EventBus.js'
import FilesGroupsContainer from '../File/FilesGroupsContainer'

const SELECTED_TAB_PROPERTY_PREFIX = 'object.tab.'

let componentKeyCounter = 0

function getTypeTabsList (typeTabsList, type, typeData) {
  // Оставляем только представления типа
  // Если представлений нет, то формируем дефолтное представление из всех свойств типа
  const defaultTabProps = []
  typeTabsList = typeTabsList.filter(tab => {
    if (tab.type === 'typeview') {
      tab.props = typeData.result[tab.id]
      return true
    } else if (tab.type === 'typeproperty') {
      defaultTabProps.push(tab)
    }
  })
  if (!typeTabsList.length && defaultTabProps.length) {
    typeTabsList.push({
      key: 'default' + (type && type.key || ''),
      name: 'Параметры',
      props: defaultTabProps
    })
  }
  return typeTabsList
}

export default {
  props: {
    objectId: { // -> local
      type: Number,
      default: null
    },
    objectParams: {
      type: Object,
      default: null
    },
    cardParams: {
      type: Object,
      default: null
    },
    objectData: {
      type: Object,
      default: null
    },
    typeKey: {
      type: String,
      default: null
    },
    headerHidden: { // -> local
      type: Boolean,
      default: false
    },
    closable: { // -> local
      type: Boolean,
      default: false
    },
    modeCustom: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    create: {
      type: Boolean,
      default: false
    },
    createConfig: {
      type: Object,
      default: null
    },
    subtypeKey: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      loading: false,
      isMounted: false,

      createLocal: this.create,

      typeKeyLocal: null, // @Default
      typeName: null,
      typeShownLocal: true, // @Default
      typeData: null, // @Private

      routed: false,
      objectIdLocal: null,
      headerShownLocal: !this.headerHidden,
      closableLocal: this.closable,
      expandCardBtnHidden: false,

      objectSrc: null,
      objectName: null,
      objectInitial: null,
      indicateChanges: false,

      typeTabs: null,
      selectedTabKey: null,
      tabsShown: false,

      access: this.getDefaultAccess()
      // objectAssess: {
      //   edit: true
      // }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    selectedTab: function () {
      if (this.typeTabs && this.selectedTabKey) {
        return this.typeTabs[this.selectedTabKey]
      }
      return null
    },
    selectedTabMounted: function () {
      return !!(this.objectSrc && this.typeTabs && this.selectedTab && this.selectedTab.component)
    },
    getYandexMapsLocationUrl: function () {
      if (this.objectSrc.location && this.objectSrc.location.length) {
        return this.$d.getYandexMapsLocationUrl(this.objectSrc.location[0])
      } else {
        return null
      }
    },
    objectCardUrl: function () {
      if (this.objectSrc) {
        return this.$d_getUrlObjectCard(this.objectSrc.$id, this.objectSrc.$type)
      } else {
        return ''
      }
    },
    readonlyLocal: function () {
      return !!(this.readonly || !this.access.editAny) // && !this.createLocal //  || !this.objectAssess.edit
    },
    subtypeKeyLocal: function () {
      if (this.subtypeKey) {
        return this.subtypeKey
      } else if (this.routed) {
        return this.$route.query.subtypeKey || null
      }
      return null
    },
    objectNameImgSrc: function () { // @Default
      return null
    },
    objectNameImgTooltip: function () { // @Default
      return null
    },
    objectNameAdditionalInfo: function () { // @Default
      return null
    },
    objectNameAdditionalInfoStyle: function () { // @Default
      return null
    }
  },
  watch: {
    objectId: {
      handler: function (id, idOld) {
        this.objectIdLocal = id

        if (id != null || idOld != null) { // this.objectData == null && !this.$route.path.startsWith('/object/')
          this.$nextTick(() => {
            if (this.typeKeyLocal != null) {
              console.log('>>> 1 objectId')
              this.updateCard()
            }
          })
        }
      },
      immediate: true
    },
    typeKey: {
      handler: function (objectTypeKey) {
        this.setObjectType(objectTypeKey)
      },
      immediate: true
    },
    create: {
      handler: function (create) {
        this.createLocal = create
      },
      immediate: true
    },
    objectData: {
      handler: function (objectData, objectDataOld) {
        if (objectData != null || objectDataOld != null) {
          console.log('>>> 2 objectData')
          this.updateCard()
        }
      }
    },
    selectedTabKey: function (value) {
      if (this.typeKeyLocal && value) {
        localStorage.setItem(SELECTED_TAB_PROPERTY_PREFIX + this.typeKeyLocal, value)
      }
    }
  },
  created: function () {
    if ((this.objectIdLocal == null || this.typeKeyLocal == null) && this.$route.path.startsWith('/object/')) {
      this.routed = true
      this.getObjectId().then(result => {
        this.objectIdLocal = result
        this.setObjectType(this.$route.params.type)
        this.headerShownLocal = true
        this.closableLocal = true

        console.log('>>> 0')
        this.updateCard()
      }, (error) => {
        this.$q.notify({
          type: 'negative',
          message: error.message,
          onDismiss: () => {
            window.close()
          }
        })
      })
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.isMounted = true
      this.$emit('mounted')
    })
    EventBus.$on('image-uploaded', this.updateImage)
    EventBus.$on('update-structure', this.updateObject)
    EventBus.$on('update-amount-control', this.updateAmountControl)
    EventBus.$on('save-object-changed-properties', this.onSaveChangedPropertiesRequestedFromOutside)
  },
  beforeDestroy: function () {
    EventBus.$off('image-uploaded', this.updateImage)
    EventBus.$off('update-structure', this.updateObject)
    EventBus.$off('update-amount-control', this.updateAmountControl)
    EventBus.$off('save-object-changed-properties', this.onSaveChangedPropertiesRequestedFromOutside)
  },
  methods: {
    updateImage: async function () {
      await this.saveChangedProperties(null, {})
    },
    getUser: function () {
      return this.user && this.user.systemUser ? this.user : null
    },
    getPromisedNotNullResult: function (getResultFn) {
      return this.getPromisedResult(() => getResultFn() != null, getResultFn)
    },
    getPromisedResult: function (conditionFn, getResultFn) {
      return new Promise((resolve, reject) => {
        if (conditionFn()) {
          resolve(getResultFn())
        } else {
          const timer = setInterval(() => {
            if (conditionFn()) {
              clearInterval(timer)
              resolve(getResultFn())
            }
          }, 250)
        }
      })
    },

    showTab: function (selectedTabKey) {
      if (this.selectedTabKey === selectedTabKey) {
        return Promise.resolve(this.$refs.selectedTabSection)
      } else {
        this.selectedTabKey = selectedTabKey
        return new Promise(resolve => {
          this.$nextTick(() => {
            if (this.selectedTabMounted) {
              resolve(this.$refs.selectedTabSection)
            } else {
              const unwatch = this.$watch('selectedTabMounted', function (selectedTabMounted) {
                if (selectedTabMounted) {
                  resolve(this.$refs.selectedTabSection)
                  if (unwatch) {
                    unwatch()
                  }
                }
              }, {
                immediate: true
              })
            }
          })
        })
      }
    },

    updateCard: function () {
      const userPromise = this.getPromisedNotNullResult(this.getUser)
      const typeDataPromise = this.getTypeData() // this.loadTypeData(this.typeKeyLocal, this.subtypeKeyLocal)
      const objectDataPromise = this.getObjectData()

      this.$q.loading.show({ spinnerColor: 'blue-11' })
      return Promise.all([userPromise, typeDataPromise, objectDataPromise]).then((values) => {
        const user = values[0]
        const typeData = values[1]
        const objectData = values[2]

        this.access = this.checkUserAccess(user, objectData.access)

        const cardConfig = this.getCardConfig(user, this.access, typeData, this.typeKeyLocal, objectData)
        this.typeName = cardConfig.typeName

        const typeTabs = cardConfig.typeTabs
        this.typeTabs = typeTabs
        this.tabsShown = Object.keys(typeTabs).length > 1

        let selectedTabKey = localStorage.getItem(SELECTED_TAB_PROPERTY_PREFIX + this.typeKeyLocal)
        if (selectedTabKey && typeTabs[selectedTabKey] == null) {
          localStorage.removeItem(SELECTED_TAB_PROPERTY_PREFIX + this.typeKeyLocal)
          selectedTabKey = null
        }
        this.selectedTabKey = selectedTabKey || cardConfig.typeTabsList[0] && cardConfig.typeTabsList[0].key || null

        this.setObject(objectData.object, objectData.assess)
      }).finally(() => {
        this.$q.loading.hide()
      })
    },

    setObject: async function (objectSrc, objectAssess) {
      if (!this.typeTabs) {
        console.error('Ошибка инициализации карточки объекта')
        return
      }

      if (objectSrc && this.typeTabs) {
        Object.defineProperty(objectSrc, '_card', {
          value: this,
          writable: true,
          enumerable: false,
          configurable: true
        })

        Object.defineProperty(objectSrc, '_objectConfig', {
          value: this.typeTabs,
          writable: true,
          enumerable: false,
          configurable: true
        })

        Object.defineProperty(objectSrc, '_filesGroups', {
          value: new FilesGroupsContainer(),
          writable: true,
          enumerable: false,
          configurable: true
        })

        // Преобразуем исходные значения объекта
        Object.values(this.typeTabs).forEach(tab => {
          if (tab.props) {
            tab.props.forEach(prop => {
              if (prop.type === 'boolean') {
                // Для булевых полей делаем преобразование null => false
                if (objectSrc[prop.key] === null) {
                  objectSrc[prop.key] = false
                }
              } else if (prop.type === 'listvalue') {
                if (prop.ismultiselect) {
                  const value = objectSrc[prop.key]
                  if (value == null) {
                    objectSrc[prop.key] = []
                  } else if (!Array.isArray(value)) {
                    objectSrc[prop.key] = [value]
                  }
                }
              } else if (prop.type === 'objects') {
                // Для объектных полей делаем преобразование null => []. TODO 'object', 'objects', 'sysobject', 'sysobjects' ?
                if (objectSrc[prop.key] == null) {
                  objectSrc[prop.key] = []
                }
                const rows = objectSrc[prop.key] || []
                if (prop.initialSortFn) {
                  rows.sort(prop.initialSortFn)
                }
                objectSrc[prop.key] = rows
              } else if (prop.type === 'table' && prop._dataType === 'comments') {
                // const propData = objectSrc[prop.key]
                // const rows = transformTableColumnsFromServerFormat(propData)
                const rows = objectSrc[prop.key] || []
                if (prop.initialSortFn) {
                  rows.sort(prop.initialSortFn)
                }
                objectSrc[prop.key] = rows
              }
            })
          }
        })
      }

      await this.onObjectChanged(objectSrc)
      this.objectSrc = objectSrc
      this.objectName = objectSrc ? this.getObjectName(objectSrc) : null
      this.objectInitial = objectSrc ? JSON.parse(JSON.stringify(objectSrc)) : null
      // this.objectAssess.edit = !(objectAssess && objectAssess.edit === false)
      if (this.typeTabs && this.typeTabs.accessedDocumentsWorkAreas) {
        this.$set(this.typeTabs.accessedDocumentsWorkAreas, 'control', 0)
      }
      this.$emit('object-changed', objectSrc)
      return objectSrc
    },
    onUpdateObject: function () {
      return this.checkForUnsavedChangesAndProceedAction(this.updateObject)
    },
    updateObject: function () {
      return this.loadObjectData(this.objectIdLocal)
        .then(objectData => {
          return this.setObject(objectData.object, objectData.assess)
        })
    },
    getObjectData: function () {
      if (this.objectData) {
        return Promise.resolve({
          object: this.objectData,
          access: null
        })
      }
      const id = this.objectIdLocal
      if (id != null) {
        return this.loadObjectData(id)
      }
      return Promise.resolve({
        object: null,
        access: null
      })
    },
    loadObjectData: function (id) {
      let url
      const params = new URLSearchParams()
      if (this.createLocal) {
        url = '/service/delta/obj/typeproperties?'

        params.append('type', this.typeKeyLocal)
      } else {
        url = '/service/delta/obj/properties?'

        if (id == null) {
          id = this.objectIdLocal
        }

        params.append('id', id)
        params.append('change', false)
        params.append('defaults', true)
      }
      if (this.subtypeKeyLocal) {
        params.append('subType', this.subtypeKeyLocal)
      }
      if (this.objectParams) {
        params.append('config', JSON.stringify(this.objectParams))
      }

      this.loading = true
      return axiosGet({
        url: url + params.toString(),
        onSuccess: (response) => {
          return {
            object: response.data.result,
            access: response.data.access
          }
        },
        onFailure: 'Ошибка получения данных для карточки объекта',
        msgTarget: this,
        throws: true
      }).finally(() => {
        this.loading = false
      })
    },
    loadPropertyObjectValues: function (prop) {
      // см. ObjectField, inv.chooseInventoryObject, ObjectChooser
      // prop.type - object objects sysobject sysobjects
      // objectchoosetype all tree search
      // objectchoosesubtypes boolean
      // objectchoosetypes []
      const params = new URLSearchParams()
      params.append('type', prop.objectchoosetypes[0].id || prop.objectchoosetypes[0].key)
      params.append('subtypes', prop.objectchoosesubtypes)
      params.append('page', 1)
      params.append('start', 0)
      params.append('limit', 50)
      params.append('sort', 'name')
      params.append('dir', 'ASC')

      return axiosGet({
        url: '/service/obj/search?' + params.toString(),
        onSuccess: (response) => {
          return response.data
        },
        onFailure: 'Ошибка получения списка возможных значений',
        msgTarget: this,
        throws: true
      })
    },

    /**
     * Подготовка полей карточки
     */
    getTypeData: function () {
      if (this.typeData) {
        return Promise.resolve(cloneDeep(this.typeData))
      }
      return this.loadTypeData(this.typeKeyLocal, this.subtypeKeyLocal)
        .then(typeData => {
          this.typeData = cloneDeep(typeData)
          return typeData
        })
    },
    loadTypeData: function (typeKey, subtypeKey) {
      const params = new URLSearchParams()
      params.append('id', typeKey)
      params.append('bulkedit', false)
      params.append('appendObjects', true)
      if (subtypeKey) {
        params.append('subType', subtypeKey)
      }

      return axiosGet({
        url: '/service/delta/sysobj/typetree?' + params.toString(),
        onSuccess: async (response) => {
          const typeData = response.data
          const typeObjEntry = Object.entries(typeData.objects).find(([id, o]) => o.$key === typeKey)
          if (!typeObjEntry) {
            const errorMessage = 'Нет доступа к карточке объекта'
            this.$nextTick(() => {
              this.$q.notify({
                type: 'negative',
                message: errorMessage,
                progress: true,
                timeout: 3000
              })
              this.$emit('close')
            })
            return Promise.reject(errorMessage)
          }

          return typeData
        },
        onFailure: 'Ошибка получения информации',
        msgTarget: this,
        throws: true
      })
    },
    getCardConfig: function (user, access, typeData, typeKey, objectData) {
      const typeObjEntry = Object.entries(typeData.objects).find(([id, o]) => o.$key === typeKey)

      let typeTabsList = this.getCustomTabsList(user, access, objectData)
      if (!typeTabsList) {
        typeTabsList = getTypeTabsList(typeData.result[typeObjEntry[0]], null, typeData)

        // eslint-disable-next-line no-inner-declarations
        function readSuperTypeViews (typeObj) {
          if (typeObj && typeObj.supertype) {
            typeObj.supertype.forEach(supertype => {
              let supertypeTabsList = typeData.result[supertype.id]
              if (supertypeTabsList) {
                supertypeTabsList = getTypeTabsList(typeData.result[supertype.id], supertype, typeData)
                typeTabsList.push(...supertypeTabsList)
              }
              readSuperTypeViews(supertype)
            })
          }
        }
        readSuperTypeViews(typeObjEntry[1])

        typeTabsList = this.preparePropertiesCommon(typeTabsList, prop => typeData.objects[prop.id])
      } else {
        // eslint-disable-next-line no-inner-declarations
        function getTreeNode (nodeId) {
          let propertyNode = null
          for (const treeNodeChildren of Object.values(typeData.result)) {
            propertyNode = treeNodeChildren.find(childNode => childNode.id === nodeId)
            if (propertyNode) {
              return propertyNode
            }
          }
          return null
        }
        // eslint-disable-next-line no-inner-declarations
        function getParentNode (propertyId) {
          if (propertyId) {
            const propertyNode = getTreeNode(propertyId)
            if (propertyNode) {
              const parentNode = getParentNode(propertyNode.pid)
              return parentNode || propertyNode
            }
          }
          return null
        }

        const objectsByKey = {}
        Object.values(typeData.objects).forEach(obj => {
          if (obj.$type === 'typeproperty') {
            const existingObj = objectsByKey[obj.code]
            if (existingObj) { // дублирующее описание свойства
              // const previousParentNode = getParentNode(existingObj.$id)
              const parentNode = getParentNode(obj.$id)
              if (parentNode && parentNode.type === 'type') { // TODO сравнить по иерархии с previousParentNode или выбрать предпочтительный typeview
                // свойство принадлежит родительскому типу
                return
              }
            }
            objectsByKey[obj.code] = obj
          }
        })
        typeTabsList = this.preparePropertiesCommon(typeTabsList, prop => objectsByKey[prop.key])
        typeTabsList = this.preparePropertiesCustom(typeTabsList)
      }

      this.prepareObjectiveProperties(typeTabsList)
      typeTabsList = this.preparePropertiesForUser(typeTabsList, user, access)
      typeTabsList = this.preparePropertiesCommonFinal(typeTabsList)

      const typeTabs = {}
      typeTabsList.forEach(tab => {
        tab.componentKey = componentKeyCounter++
        typeTabs[tab.key] = tab
      })

      return {
        typeName: typeObjEntry[1].name,
        typeTabs,
        typeTabsList
      }
    },
    getCustomTabsList: function (user, access, objectData) {
      if (this.modeCustom) {
        let typeTabsList = this.getRawCustomTabsList({
          user: user,
          access: access,
          objectData,
          create: this.createLocal,
          createConfig: this.createConfig,
          subtypeKey: this.subtypeKeyLocal
        })
        if (typeTabsList) {
          this.prepareRawCustomTabsList(typeTabsList, access)

          typeTabsList = typeTabsList.filter(tab => {
            if (tab._show) {
              return tab._show(objectData.object)
            }
            return true
          })
        }
        return typeTabsList || null
      }
      return null
    },
    preparePropertiesCommon: function (typeTabsList, getPropertyData) {
      return typeTabsList.filter(tab => {
        if (tab.props) {
          tab.props = tab.props.filter(prop => {
            // Оставляем кастомные элементы карточки
            if (prop.type === 'separator') {
              return true
            }

            const propertyData = getPropertyData(prop)
            if (propertyData) {
              // Обогащаем элемент карточки (поле) описанием из бд
              const propCopy = Object.assign(propertyData || {}, prop)
              propCopy.type = prop.proptype || propertyData.type
              prop = Object.assign(prop, propCopy)
            } else if (prop.type) {
              // Тип объекта определен в кастомном описании
              if (!prop.code) {
                // prop.code = prop.key
                if (!prop._customEdit) {
                  // Если у свойства нет code, то оно не сохранится
                  prop.editable = false
                }
              }
              if (!prop.component) {
                console.log('CUSTOM: ' + (prop.name ? prop.name + ' - ' : '') + prop.key + (prop.code ? '' : ' - CONFIG NOT ENOUGH'))
              }
            } else {
              // Убираем элементы карточки, для которых отсутствует описание из бд и нет кастомного описания
              console.log('EXCLUDED: ' + (prop.name ? prop.name + ' - ' : '') + prop.key)
              return false
            }

            // Преобразование формата конфигурации
            transformPropertyConfiguration(prop)
            // Название большими буквами
            if (prop.name) {
              prop._nameUpperCase = prop.name.toUpperCase()
            }
            // Иконка
            if (!prop._icon) {
              const icon = getPropertyIcon(prop)
              if (icon) {
                prop._icon = icon
              }
            }
            // Кастомный компонент
            if (prop.component) {
              if (typeof prop.component === 'string') {
                if (prop.component.endsWith('.vue')) {
                  prop.component = import(prop.component)
                } else {
                  prop.component = null
                }
              }
            }
            return true
          })
        }
        return true
      })
    },
    preparePropertiesCommonFinal: function (typeTabsList) {
      return typeTabsList.filter(tab => {
        if (tab.props) {
          // Убираем сепараторы, после которых нет элементов
          const props = []
          for (let i = 0; i < tab.props.length; i++) {
            if (tab.props[i].type === 'separator') {
              if (i + 1 === tab.props.length || tab.props[i + 1].type === 'separator') {
                continue
              }
            }
            props.push(tab.props[i])
          }
          tab.props = props
        }

        // Если представление использует стандартный компонент и не имеет полей, то убираем его
        if (!tab.component) {
          if (tab.props && tab.props.length) {
            tab.component = CardSectionProperties
          } else if (tab.key === 'files' || tab.key === 'documents') {
            tab.component = CardSectionDocuments // 'documents'
            tab.componentProps = {
              propertyKey: tab.key
            }
          } else {
            return false
          }
        }
        if (tab.component && typeof tab.component === 'string') {
          let path = null
          if (tab.component === 'documents') {
            path = '../../../src/components/card/CardSectionDocuments.vue'
          }
          if (path) {
            tab.component = import(path)
          } else {
            return false
          }
        }
        return true
      })
    },
    prepareObjectiveProperties: function (typeTabsList) {
      const searches = {}
      typeTabsList.forEach(tab => {
        tab.props && tab.props.forEach((prop) => {
          if (prop._select && prop.objectchoosetypes && prop.objectchoosetypes.length) { // TODO проверить тип
            const searchConfig = {
              objectchoosetypes: prop.objectchoosetypes,
              objectchoosesubtypes: !!prop.objectchoosetypes
            }
            const searchConfigStr = JSON.stringify(searchConfig)
            const search = searches[searchConfigStr]
            if (search) {
              search.propsKeys.push(prop.key)
            } else {
              searches[searchConfigStr] = {
                config: searchConfig,
                propsKeys: [prop.key]
              }
            }
          }
        })
      })

      try {
        Object.values(searches).forEach(search => {
          (async () => {
            const searchResult = await this.loadPropertyObjectValues(search.config)
            // searchResult.count

            typeTabsList.forEach(tab => {
              tab.props && tab.props.forEach((prop) => {
                if (search.propsKeys.includes(prop.key)) {
                  this.$set(prop, '_select', true)
                  this.$set(prop, 'listvalues', searchResult.result)
                  this.$set(prop, 'ismultiselect', prop.type === 'objects' || prop.type === 'sysobjects')
                }
              })
            })
          })()
        })
      } catch (ignored) {
      }
    },
    preparePropertiesForUser: function (typeTabsList, user, access) {
      const hasAccessToEditPublic = !!access.editPublic

      return typeTabsList.filter(tab => {
        if (tab._visible === false) {
          return false
        }

        if (this.readonly) {
          tab.editable = false
        } else {
          tab.editable = hasAccessToEditPublic
        }

        if (tab.props) {
          tab.props = tab.props.filter(prop => {
            prop._prepare && prop._prepare(user)

            if (prop._visible === false) {
              return false
            }

            if (this.readonly) {
              prop.editable = false
            } else if (prop._editable != null) {
              prop.editable = prop._editable
            } else {
              prop.editable = !!prop.editable && hasAccessToEditPublic
            }
            return true
          })
        }
        return true
      })
    },

    /**
     * Проверка и сохранение изменений
     */
    onSaveObject: function () {
      // см. ObjectConfPanel.saveProperties(), ObjectViewsPanel.getChangedProperties
      if (!this.objectSrc) {
        // 'Внимание', 'Объект не указан'
        return
      }

      const changedProperties = this.getChangedProperties()
      const hasChangedProperties = Object.keys(changedProperties).length !== 0
      const hasChangedFilesGroups = this.hasChangedFilesGroups()
      if (!hasChangedProperties && !hasChangedFilesGroups) {
        this.$q.notify({
          type: 'warning',
          message: this.createLocal ? 'Не заполнены поля' : 'Нет изменений',
          progress: true,
          timeout: 3000
        })
        return
      }

      this.$d_ask({
        callback: () => {
          this.saveObject(changedProperties, hasChangedFilesGroups)
        },
        header: this.createLocal ? `Создать объект "${this.typeName}"?` : 'Сохранить изменения?'
      })
    },
    saveObject: async function (changedProperties, hasChangedFilesGroups) {
      if (changedProperties == null) {
        changedProperties = this.getChangedProperties()
      }
      const hasChangedProperties = Object.keys(changedProperties).length !== 0
      if (hasChangedFilesGroups == null) {
        hasChangedFilesGroups = this.hasChangedFilesGroups()
      }

      let reloadIsRequired = false
      if (hasChangedProperties) {
        try {
          this.$q.loading.show({ spinnerColor: 'blue-11' })
          let savePropertiesResult = null
          if (this.createLocal) {
            savePropertiesResult = await this.createObject(changedProperties)
          } else {
            savePropertiesResult = await this.saveChangedProperties(null, changedProperties)
          }
          if (savePropertiesResult.reload) {
            reloadIsRequired = true
          }

          // TODO refactor updateAmountControl :
          this.updateAmountControl(null, 0)

          EventBus.$emit('object-card-saved', {
            id: this.createLocal ? savePropertiesResult.id : this.objectIdLocal || this.objectData.id,
            action: this.createLocal ? 'create' : 'save',
            savePropertiesResult,
            changedProperties
          })
        } catch (e) {
          console.log(e)
        } finally {
          this.$q.loading.hide()
        }
      }
      if (hasChangedFilesGroups) {
        try {
          this.$q.loading.show({ spinnerColor: 'blue-11' })
          await this.saveFilesGroups()
          reloadIsRequired = true
        } catch (e) {
          console.log(e)
        } finally {
          this.$q.loading.hide()
        }
      }
      if (reloadIsRequired) {
        try {
          this.$q.loading.show({
            message: 'Обновление данных',
            messageColor: 'blue-11',
            spinnerColor: 'blue-11'
          })
          await this.updateObject()
        } catch (e) {
          console.log(e)
        } finally {
          this.$q.loading.hide()
        }
      }
    },
    getChangedProperties: function (noRelationships = false) {
      const properties = {}
      if (this.typeTabs) {
        Object.values(this.typeTabs).forEach(tab => {
          tab.props && tab.props.forEach(prop => {
            if (!prop.code || prop.storable === false) {
              return
            }
            const value = this.objectSrc[prop.key] // displayValue
            const valueInitial = this.objectInitial[prop.key]
            // TODO проверить преобразование пустых значения
            if (!this.createLocal) {
              if (prop.type === 'string' && typeof valueInitial === 'number') { // Случай, когда на сервере числовой тип, а на клиенте перезаписано на строковый
                if (value == valueInitial) {
                  return
                }
              } else if (value === valueInitial) {
                return
              }
              if (JSON.stringify(value) === JSON.stringify(valueInitial)) {
                return
              }
            }

            let type = prop.type
            if (type === 'any') {
              type = 'string' // TODO any type
            }
            const code = prop.code
            if (noRelationships) {
              properties[code] = value
            } else {
              if (prop.saveRawData) {
                properties[code] = value
              } else if (type === 'object' || type === 'sysobject' || type === 'fileobject') {
                if (Array.isArray(value)) {
                  if (value.length > 0 && value[0]) {
                    const object = value[0]
                    const relValue = {}
                    relValue[object.id] = object.props ? object.props : {}
                    properties['#' + code] = relValue
                  } else {
                    properties['#' + code] = null
                  }
                }
              } else if (type === 'objects') {
                if (Array.isArray(value)) {
                  const relValues = {}
                  for (var j = 0; j < value.length; j++) {
                    const object = value[j]
                    const relValue = relValues[object.id]
                    const newRelValue = object.props ? object.props : {}
                    if (!relValue) {
                      relValues[object.id] = newRelValue
                    } else if (Array.isArray(relValue)) {
                      relValue.push(newRelValue)
                    } else if (typeof relValue === 'object') {
                      relValues[object.id] = [relValue, newRelValue]
                    }
                  }
                  properties['#' + code] = relValues
                }
              } else if (type === 'table' && prop._dataType === 'comments') {
                const tablecolumns = prop.tablecolumns
                const columnsKeys = []
                if (Array.isArray(tablecolumns)) { // Кастомное описание колонок
                  for (let i = 0; i < tablecolumns.length; i++) {
                    columnsKeys.push(tablecolumns[i].name)
                  }
                } else if (tablecolumns.name && tablecolumns.name.length) {
                  for (let i = 0; i < tablecolumns.name.length; i++) {
                    columnsKeys.push(tablecolumns.name[i])
                  }
                }

                const rows = value
                const serverValue = {}
                if (columnsKeys.length) {
                  columnsKeys.forEach(columnKey => {
                    if (!serverValue[columnKey]) {
                      serverValue[columnKey] = []
                    }
                    rows.forEach(row => {
                      serverValue[columnKey].push(row[columnKey])
                    })
                  })
                }
                properties[code] = serverValue
              } else {
                if ((code !== 'inTgroupNumber' || (code === 'inTgroupNumber' && !isNaN(value))) &&
                (code !== 'amountControl' || (code == 'amountControl' && value > 0))) {
                  properties[code] = value
                }
              }
            }
          })
        })
      }
      return properties
    },
    saveChangedProperties: function (treeNode, properties, labels, mergePolicy) { // ObjectConfPanel.saveObject
      // if (this.hasAdditional) { ... }

      const bodyFormData = new FormData()
      bodyFormData.set('id', this.objectIdLocal || this.objectData.id)
      bodyFormData.set('props', JSON.stringify(properties))
      // bodyFormData.set('labels', labels.join(','))

      // TODO вернуть обратно merge: error
      bodyFormData.set('merge', mergePolicy || 'rewrite') // rewrite error ignore
      if (this.subtypeKeyLocal) {
        bodyFormData.set('subType', this.subtypeKeyLocal)
      }
      if (this.objectParams) {
        bodyFormData.set('config', JSON.stringify(this.objectParams))
      }

      return axiosPost({
        url: '/service/delta/obj/setproperties',
        data: bodyFormData,
        onSuccess: (response) => {
          const newVersion = response.data.version
          console.log('Сохранение. Версия ' + this.objectSrc.$version + ' -> ' + newVersion)
          this.objectSrc.$version = newVersion
          this.objectInitial = JSON.parse(JSON.stringify(this.objectSrc))

          this.$q.notify({
            type: 'positive',
            message: 'Изменения успешно сохранены',
            progress: true,
            timeout: 3000
          })

          this.emitSaved()

          return response.data
        },
        onFailure: (response) => {
          // TODO merge

          const message = response.message || 'Ошибка сохранения свойств объекта'
          this.$q.notify({
            type: 'negative',
            message: message,
            progress: true,
            timeout: 5000
          })
          throw new Error(message)
        }
      })
    },
    onSaveChangedPropertiesRequestedFromOutside: function (changedProperties) {
      if (this.objectIdLocal || this.objectData && this.objectData.id) { // Вероятно, есть второй экзепляр компонента, который не содержит этих полей, и метод saveChangedProperties падает с ошибкой
        this.saveChangedProperties(null, changedProperties)
      }
    },
    createObject: function (properties) {
      const bodyFormData = new FormData()
      bodyFormData.set('props', JSON.stringify(properties))

      if (this.subtypeKeyLocal) {
        bodyFormData.set('subType', this.subtypeKeyLocal)
      }
      if (this.objectParams) {
        bodyFormData.set('config', JSON.stringify(this.objectParams))
      }

      return axiosPost({
        url: '/service/delta/' + this.typeKeyLocal + '/create',
        data: bodyFormData,
        onSuccess: (response) => {
          this.objectIdLocal = response.data.id
          this.createLocal = false
          this.objectInitial = JSON.parse(JSON.stringify(this.objectSrc))

          this.$q.notify({
            type: 'positive',
            message: 'Создание успешно',
            progress: true,
            timeout: 3000
          })

          this.$emit('created', this.objectIdLocal)

          return response.data
        },
        onFailure: (response) => {
          // TODO merge

          const message = response.message || 'Ошибка создания объекта'
          this.$q.notify({
            type: 'negative',
            message: message,
            progress: true,
            timeout: 5000
          })
          throw new Error(message)
        }
      })
    },
    emitSaved: function () {
      this.$emit('saved')
    },
    hasChanges: function () {
      const properties = this.getChangedProperties()
      if (Object.keys(properties).length !== 0) {
        return true
      }
      return this.hasChangedFilesGroups()
    },
    hasChangedFilesGroups: function () {
      if (this.objectSrc && this.objectSrc._filesGroups) {
        return this.objectSrc._filesGroups.hasChanges()
      }
      return false
    },
    saveFilesGroups: function () {
      const filesUpdatePasportRoads = this.objectSrc._filesGroups.filesGroups.find(item => item.key == 'serviceObjectPassportRoads' && item.filesToUpdate.length > 0)
      const promises = []
      if (filesUpdatePasportRoads !== undefined) {
        promises.push(this.editFilesInUse(filesUpdatePasportRoads.filesToUpdate))
      }
      promises.push(this.objectSrc._filesGroups.saveFilesChanges({
        notify: true,
        target: this
      }))
      return Promise.all(promises)
    },

    /**
     * Дефолтные методы
     */
    // При установке значения typeKeyLocal в data дочернего элемента
    // нужно переопределить метод, сделать его пустым.
    // Иначе typeKeyLocal перезапишется
    // @Default
    setObjectType: function (objectTypeKey) {
      this.typeKeyLocal = objectTypeKey
    },
    // @Default
    getObjectName: function (objectSrc) {
      return objectSrc.name || objectSrc.key
    },
    // @Default
    getObjectId: async function () {
      return Promise.resolve(this.$route.params.id)
    },
    // @Default
    onObjectChanged: function (objectSrc) {
    },
    // @Default
    getRawCustomTabsList: function (config) {
      return null
    },
    // @Default
    prepareRawCustomTabsList (customTabsList) {
      customTabsList.forEach(tab => {
        if (tab.props) {
          const preparedProps = []
          tab.props.forEach(prop => {
            if (typeof prop === 'string') {
              prop = { key: prop }
            }
            preparedProps.push(prop)
          })
          tab.props = preparedProps
        }
      })
    },
    // @Default
    preparePropertiesCustom: function (typeTabsList) {
      return typeTabsList
    },
    // @Default
    checkUserAccess: function (user, objectAssess) {
      return this.getDefaultAccess(user, objectAssess)
    },
    // @Default
    getDefaultAccess: function (user, objectAssess) {
      return {
        viewPublic: false,
        viewPrivate: false,
        editPublic: false,
        editPrivate: false,
        editAny: false
      }
    },

    // === Логика компонента
    checkForUnsavedChangesAndProceedAction: function (actionCallback, actionCallbackArgs = []) {
      // TO DO: hasChanges при создании и спрашивать в диалоге
      if (this.hasChanges() && !this.createLocal) {
        return new Promise((resolve, reject) => {
          this.$d_ask({
            callback: async (data, action) => {
              let callbackResult = null
              if (action === 'yes') {
                await this.saveObject()
                callbackResult = await actionCallback(...actionCallbackArgs)
              } else if (action === 'no') {
                callbackResult = await actionCallback(...actionCallbackArgs)
              }
              resolve(callbackResult)
            },
            header: this.createLocal ? `Создать объект "${this.typeName}"?` : 'Сохранить изменения?',
            warning: [this.createLocal ? 'Введённые данные будут потеряны' : 'Несохранённые изменения будут потеряны'],
            buttons: {
              yes: 'Да',
              no: 'Нет',
              cancel: 'Отмена'
            }
          })
        })
      } else {
        return actionCallback(...actionCallbackArgs)
      }
    },
    onClose: function () {
      this.checkForUnsavedChangesAndProceedAction(this.close)
    },
    close: function () {
      if (this.routed) {
        if (window.history.length != 1 && window.history.state !== null) {
          this.$router.back()
        } else {
          this.$router.push('/')
        }
      } else {
        this.$emit('close')
      }
    },
    onExpand: function ($event) {
      this.$d_showObjectCard(this.objectIdLocal, this.typeKeyLocal, $event ? $event.ctrlKey : false)
    },
    updateAmountControl: function (key, amount) {
      if (this.typeTabs && Object.keys(this.typeTabs).length > 0) {
        if (key && this.typeTabs[key] !== undefined && this.typeTabs[key].control !== undefined) {
          this.$set(this.typeTabs[key], 'control', amount)
        } else if (key === null) {
          Object.keys(this.typeTabs).forEach(_key => {
            if (this.typeTabs[_key].control !== undefined) {
              this.$set(this.typeTabs[_key], 'control', amount)
            }
          })
        }
      }
    },
    editFilesInUse: function (files) {
      const bodyFormData = new FormData()
      const filesChanges = []
      files.forEach(file => {
        if (file.document && (!file.documentInitial || file.documentInitial.inUse != file.document.inUse)) {
          filesChanges.push({ id: file.id, inUse: file.document.inUse })
        }
      })
      if (filesChanges.length === 0) {
        return Promise.resolve()
      }

      bodyFormData.set('filesConf', JSON.stringify(filesChanges))
      return axiosPost({
        url: '/service/delta/document/editFiles',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Изменение актуальности документов',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (response) => {
          const mes = response.message ? response.message : 'Ошибка изменения актуальности документов!'
          this.$q.notify({
            type: 'negative',
            message: mes,
            progress: true,
            timeout: 10000
          })
        },
        msgTarget: this
      })
    }
  }
}

